import { Injectable } from '@angular/core';
import { ITerminologyService } from 'terminology-lib';

@Injectable({ providedIn: 'root' })
export class BullhornTerminologyService implements ITerminologyService {
  get name(): string {
    return 'Bullhorn';
  }

  get anarthrous(): string {
    return 'a';
  }

  get recordName(): string {
    return 'entity';
  }

  get recordNamePlural(): string {
    return 'entities';
  }

  get recordAnarthrous(): string {
    return 'an';
  }

  get recipientType(): string {
    return 'Entity';
  }

  get fileType(): string {
    return 'File';
  }
}
